export function extractTenantSlug(
  hostname: string,
  tenantBaseHost: string,
): string | null {
  const normalizedHost = hostname.trim().toLowerCase();

  if (!normalizedHost || normalizedHost === 'localhost' || normalizedHost === '127.0.0.1') {
    return null;
  }

  const normalizedBaseHost = tenantBaseHost.trim().toLowerCase();

  if (normalizedHost === normalizedBaseHost) {
    return null;
  }

  if (normalizedHost.endsWith(`.${normalizedBaseHost}`)) {
    const slug = normalizedHost.slice(0, -(normalizedBaseHost.length + 1));
    return slug || null;
  }

  return null;
}
